"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeDateTimePicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("../../../hooks");
var _Menu = require("../../Menu");
var _dates = require("../../../utilities/dates");
var _RangeDatePicker = require("../RangeDatePicker");
var _TimePickerArea = require("./partials/TimePickerArea");
var _DateTimePickers = require("../DateTimePickers.labels");
var _RangeDateTimePicker = _interopRequireDefault(require("./RangeDateTimePicker.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getValidProps = function getValidProps(props) {
  var startDateTimeProp = props.startDateTime,
    endDateTimeProp = props.endDateTime,
    minDateTimeProp = props.minDateTime,
    maxDateTimeProp = props.maxDateTime,
    deltaHoursProp = props.deltaHours,
    minutesStep = props.minutesStep;
  var minDateTime = minDateTimeProp ? (0, _dates.restrictToMinuteStep)(new Date(minDateTimeProp), minutesStep, true) : undefined;
  var maxDateTime = maxDateTimeProp ? (0, _dates.restrictToMinuteStep)(new Date(maxDateTimeProp), minutesStep, false) : undefined;
  if (minDateTime && maxDateTime && minDateTime > maxDateTime) {
    minDateTime = maxDateTime;
  }
  var deltaHours = deltaHoursProp && deltaHoursProp > 0 ? deltaHoursProp : 2;
  var nowDateTime = new Date();
  var futureDateTime = new Date();
  futureDateTime.setHours(futureDateTime.getHours() + deltaHours);
  var defaultStartDate = minDateTime && nowDateTime < minDateTime ? minDateTime : nowDateTime;
  var defaultEndDate = maxDateTime && nowDateTime > maxDateTime ? maxDateTime : futureDateTime;
  var startDateTime = startDateTimeProp ? startDateTimeProp : defaultStartDate;
  var endDateTime = endDateTimeProp && startDateTime <= endDateTimeProp ? endDateTimeProp : (0, _dates.restrictToMinDate)(endDateTimeProp !== null && endDateTimeProp !== void 0 ? endDateTimeProp : defaultEndDate, startDateTime);

  // TODO: Temporary removed because test automation failure. should fix automation and back to this version in the future!
  //startDateTime = restrictToMinuteStep(startDateTime, minutesStep);
  //endDateTime = restrictToMinuteStep(endDateTime, minutesStep);

  return _objectSpread(_objectSpread({}, props), {}, {
    startDateTime: startDateTime,
    endDateTime: endDateTime,
    minDateTime: minDateTime,
    maxDateTime: maxDateTime
  });
};
var RangeDateTimePicker = function RangeDateTimePicker(props) {
  var _currentRangeDates$, _currentRangeDates$2;
  var styles = (0, _RangeDateTimePicker.default)();
  var getLabel = (0, _hooks.useLabels)({
    labels: _DateTimePickers.labels
  });
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _getValidProps = getValidProps(props),
    startDateTime = _getValidProps.startDateTime,
    endDateTime = _getValidProps.endDateTime,
    minDateTime = _getValidProps.minDateTime,
    maxDateTime = _getValidProps.maxDateTime,
    anchorSubTextStartDate = _getValidProps.anchorSubTextStartDate,
    anchorSubTextStartTime = _getValidProps.anchorSubTextStartTime,
    deltaHours = _getValidProps.deltaHours,
    minutesStep = _getValidProps.minutesStep,
    anchorSubTextEndDate = _getValidProps.anchorSubTextEndDate,
    anchorSubTextEndTime = _getValidProps.anchorSubTextEndTime,
    dateTitle = _getValidProps.dateTitle,
    startTimeTitle = _getValidProps.startTimeTitle,
    endTimeTitle = _getValidProps.endTimeTitle,
    isDisabled = _getValidProps.isDisabled,
    _getValidProps$attach = _getValidProps.attachedTo,
    attachedTo = _getValidProps$attach === void 0 ? 'StartEndDates' : _getValidProps$attach,
    defaultBtnProps = _getValidProps.btnProps,
    onChange = _getValidProps.onChange;
  var startDateTimestamp = (0, _react.useRef)();
  var endDateTimestamp = (0, _react.useRef)();
  var _useState = (0, _react.useState)([startDateTime, endDateTime]),
    _useState2 = _slicedToArray(_useState, 2),
    currentRangeDates = _useState2[0],
    setCurrentRangeDates = _useState2[1];
  var _useState3 = (0, _react.useState)(startDateTime),
    _useState4 = _slicedToArray(_useState3, 2),
    currentStartDateTime = _useState4[0],
    setCurrentStartDateTime = _useState4[1];
  var _useState5 = (0, _react.useState)(endDateTime),
    _useState6 = _slicedToArray(_useState5, 2),
    currentEndDateTime = _useState6[0],
    setCurrentEndDateTime = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = _slicedToArray(_useState7, 2),
    minStartTime = _useState8[0],
    setMinStartTime = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = _slicedToArray(_useState9, 2),
    maxStartTime = _useState10[0],
    setMaxStartTime = _useState10[1];
  var _useState11 = (0, _react.useState)(),
    _useState12 = _slicedToArray(_useState11, 2),
    minEndTime = _useState12[0],
    setMinEndTime = _useState12[1];
  var _useState13 = (0, _react.useState)(),
    _useState14 = _slicedToArray(_useState13, 2),
    maxEndTime = _useState14[0],
    setMaxEndTime = _useState14[1];
  var btnProps = _objectSpread({
    color: 'basic',
    view: 'outlined',
    shape: isMobileView ? 'roundedRectangle' : 'ellipse',
    customStyle: {
      height: 'unset',
      width: isMobileView ? '100%' : 'auto'
    },
    isDisabled: isDisabled,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-RangeDateTimePicker__anchor-btn'],
      children: [(attachedTo === 'StartDate' || attachedTo === 'StartEndDates') && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: (0, _dates.formatDate)(startDateTime, '{day}.{month}.{year}')
          }), anchorSubTextStartDate && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: anchorSubTextStartDate
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: (0, _dates.formatDate)(startDateTime, '{hour}:{minute}')
          }), anchorSubTextStartTime && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: anchorSubTextStartTime
          })]
        })]
      }), attachedTo === 'StartEndDates' && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {}), (attachedTo === 'EndDate' || attachedTo === 'StartEndDates') && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: (0, _dates.formatDate)(endDateTime, '{day}.{month}.{year}')
          }), anchorSubTextEndDate && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: anchorSubTextEndDate
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: (0, _dates.formatDate)(endDateTime, '{hour}:{minute}')
          }), anchorSubTextEndTime && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: anchorSubTextEndTime
          })]
        })]
      })]
    })
  }, defaultBtnProps);
  var updateMinMaxTimeValues = (0, _react.useCallback)(function (start, end) {
    if (attachedTo === 'StartEndDates' && start.toDateString() === end.toDateString()) {
      setMinEndTime({
        hour: start.getHours(),
        minute: end.getHours() <= start.getHours() ? start.getMinutes() : undefined
      });
    } else {
      // In case when user select min/max date in range:
      // Set max/min available time (hour + minute) values

      setMinStartTime(minDateTime && start.toDateString() === minDateTime.toDateString() ? {
        hour: minDateTime.getHours(),
        minute: start.getHours() <= minDateTime.getHours() ? minDateTime.getMinutes() : undefined
      } : undefined);
      setMinEndTime(minDateTime && end.toDateString() === minDateTime.toDateString() ? {
        hour: minDateTime.getHours(),
        minute: end.getHours() <= minDateTime.getHours() ? minDateTime.getMinutes() : undefined
      } : undefined);
      setMaxStartTime(maxDateTime && start.toDateString() === maxDateTime.toDateString() ? {
        hour: maxDateTime.getHours(),
        minute: end.getHours() >= maxDateTime.getHours() ? maxDateTime.getMinutes() : undefined
      } : undefined);
      setMaxEndTime(maxDateTime && end.toDateString() === maxDateTime.toDateString() ? {
        hour: maxDateTime.getHours(),
        minute: end.getHours() >= maxDateTime.getHours() ? maxDateTime.getMinutes() : undefined
      } : undefined);
    }
  }, [attachedTo, maxDateTime, minDateTime]);
  var getStartDateTimeWithDelta = function getStartDateTimeWithDelta(start) {
    var startDateTimeWithDelta = new Date(start);
    if (deltaHours && deltaHours > 0) {
      var endOfTheStartDay = new Date(start);
      endOfTheStartDay.setHours(23, 59, 0, 0);
      startDateTimeWithDelta.setTime(start.getTime() + deltaHours * 60 * 60 * 1000);
      startDateTimeWithDelta = (0, _dates.restrictToMaxDate)(startDateTimeWithDelta, (0, _dates.restrictToMinuteStep)(endOfTheStartDay, minutesStep, false));
      startDateTimeWithDelta = (0, _dates.restrictToMaxDate)(startDateTimeWithDelta, maxDateTime);
    }
    return startDateTimeWithDelta;
  };
  var handleRangeDateChange = function handleRangeDateChange(startDate, endDate) {
    setCurrentRangeDates([startDate !== null && startDate !== void 0 ? startDate : null, endDate !== null && endDate !== void 0 ? endDate : null]);
    if (startDate) {
      updateDates(startDate, endDate !== null && endDate !== void 0 ? endDate : startDate);
    } else if (endDate) {
      updateDates(startDate !== null && startDate !== void 0 ? startDate : endDate, endDate);
    }
  };
  var initDates = (0, _react.useCallback)(function () {
    startDateTimestamp.current = startDateTime.getTime();
    endDateTimestamp.current = endDateTime.getTime();
    setCurrentStartDateTime(startDateTime);
    setCurrentEndDateTime(endDateTime);
    setCurrentRangeDates([startDateTime, endDateTime]);
    updateMinMaxTimeValues(startDateTime, endDateTime);
  }, [endDateTime, startDateTime, updateMinMaxTimeValues]);
  var updateDates = function updateDates(start, end) {
    var newCurrentStartDateTime = new Date(currentStartDateTime);
    newCurrentStartDateTime.setDate(start.getDate());
    newCurrentStartDateTime.setMonth(start.getMonth());
    newCurrentStartDateTime.setFullYear(start.getFullYear());
    newCurrentStartDateTime.setSeconds(0, 0);
    var newCurrentEndDateTime = new Date(currentEndDateTime);
    newCurrentEndDateTime.setDate(end.getDate());
    newCurrentEndDateTime.setMonth(end.getMonth());
    newCurrentEndDateTime.setFullYear(end.getFullYear());
    newCurrentEndDateTime.setSeconds(0, 0);
    if (newCurrentEndDateTime <= newCurrentStartDateTime) {
      newCurrentEndDateTime = deltaHours ? getStartDateTimeWithDelta(newCurrentStartDateTime) : newCurrentStartDateTime;
    }
    setCurrentStartDateTime(newCurrentStartDateTime);
    setCurrentEndDateTime(newCurrentEndDateTime);
    updateMinMaxTimeValues(newCurrentStartDateTime, newCurrentEndDateTime);
  };
  var handleStartTimeChange = function handleStartTimeChange(newCurrentStartDateTime) {
    var newCurrentEndDateTime = new Date(currentEndDateTime);
    if (newCurrentEndDateTime <= newCurrentStartDateTime) {
      newCurrentEndDateTime = deltaHours ? getStartDateTimeWithDelta(newCurrentStartDateTime) : newCurrentStartDateTime;
      setCurrentEndDateTime(newCurrentEndDateTime);
    }
    setCurrentStartDateTime(newCurrentStartDateTime);
    updateMinMaxTimeValues(newCurrentStartDateTime, newCurrentEndDateTime);
  };
  var handleEndTimeChange = function handleEndTimeChange(newCurrentEndDateTime) {
    setCurrentEndDateTime(newCurrentEndDateTime);
    updateMinMaxTimeValues(currentStartDateTime, newCurrentEndDateTime);
  };
  var handleConfirm = function handleConfirm() {
    if (onChange) {
      onChange(currentStartDateTime, currentEndDateTime);
    }
  };
  var handleCancel = function handleCancel() {
    initDates();
  };
  (0, _react.useEffect)(function () {
    if (startDateTimestamp.current !== startDateTime.getTime() || endDateTimestamp.current !== endDateTime.getTime()) {
      initDates();
    }
  }, [endDateTime, startDateTime, initDates]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-RangeDateTimePicker'],
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Menu.Menu, {
      defaultTitle: attachedTo === 'StartDate' ? getLabel('choose') + anchorSubTextStartDate : attachedTo === 'EndDate' ? getLabel('choose') + anchorSubTextEndDate : getLabel('choose_date_time'),
      isBoxCenteredToAnchor: true,
      anchorWidth: isMobileView ? 'auto' : 'fit-content',
      btnProps: btnProps,
      isWithActionButtons: true,
      isFullScreen: isMobileView,
      onConfirm: handleConfirm,
      onCancel: handleCancel,
      children: [dateTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-RangeDateTimePicker__inner-title'],
        children: dateTitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RangeDatePicker.RangeDatePicker, {
        minDate: minDateTime,
        maxDate: maxDateTime,
        startDate: (_currentRangeDates$ = currentRangeDates === null || currentRangeDates === void 0 ? void 0 : currentRangeDates[0]) !== null && _currentRangeDates$ !== void 0 ? _currentRangeDates$ : undefined,
        endDate: (_currentRangeDates$2 = currentRangeDates === null || currentRangeDates === void 0 ? void 0 : currentRangeDates[1]) !== null && _currentRangeDates$2 !== void 0 ? _currentRangeDates$2 : undefined,
        attachedTo: attachedTo,
        onChange: handleRangeDateChange
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: styles['cc-RangeDateTimePicker__time-container'],
        children: [(attachedTo === 'StartDate' || attachedTo === 'StartEndDates') && /*#__PURE__*/(0, _jsxRuntime.jsx)(_TimePickerArea.TimePickerArea, {
          dateTime: currentStartDateTime,
          minTime: minStartTime,
          maxTime: maxStartTime,
          minutesStep: minutesStep,
          title: startTimeTitle,
          onChange: handleStartTimeChange
        }), (attachedTo === 'EndDate' || attachedTo === 'StartEndDates') && /*#__PURE__*/(0, _jsxRuntime.jsx)(_TimePickerArea.TimePickerArea, {
          dateTime: currentEndDateTime,
          minTime: minEndTime,
          maxTime: maxEndTime,
          minutesStep: minutesStep,
          title: endTimeTitle,
          onChange: handleEndTimeChange
        })]
      })]
    })
  });
};
exports.RangeDateTimePicker = RangeDateTimePicker;